export let VideoUrl;
(function (VideoUrl) {
  VideoUrl["MP4_360"] = "360p.mp4";
  VideoUrl["MP4_380"] = "480p.mp4";
  VideoUrl["MP4_720"] = "720p.mp4";
  VideoUrl["MP4_1080"] = "1080p.mp4";
  VideoUrl["HLS"] = "hls.m3u8";
  VideoUrl["DASH"] = "dash.mpd";
  VideoUrl["STORYBOARD"] = "storyboard-144p.mp4";
  VideoUrl["CLIP_480"] = "clip-480p.mp4";
  VideoUrl["CLIP_720"] = "clip-720p.mp4";
  VideoUrl["CLIP_HLS"] = "clip-hls.m3u8";
  VideoUrl["CLIP_DASH"] = "clip-dash.mpd";
})(VideoUrl || (VideoUrl = {}));
//# sourceMappingURL=video-url.js.map